const Enums = (properties) => {
  // Creates a parent class that returns the name of the type of enum
  function Enums(name){
    this.name = name
  }

  Enums.prototype.toString = function(){
    return  this.name
  }

  const NewEnumClass = function(name){
    Enums.call(this, name)
  }

  NewEnumClass.prototype = Object.create(Enums.prototype)
  NewEnumClass.prototype.constructor = NewEnumClass

  const builder = (enums) => {
    enums.forEach(
      // Creates all properties for the Enum class
      // Allows to check if property is an instanc of class
      (property) => {
        NewEnumClass[property] = new NewEnumClass(property)
      }
    )
    return NewEnumClass
  }

  return builder(properties)
}

export default Enums
